const ValuationDispositionEnum = Object.freeze({
    NONE: 'NONE',
    SOLD: 'SOLD',
    EXIT: 'EXIT',
    FAIL: 'FAIL',
    SPLIT: 'SPLIT'
});

export default ValuationDispositionEnum;
